// From dotnet new react -au individual
var StoreManager = /** @class */ (function () {
    function StoreManager() {
        this._callbacks = [];
        this._nextSubscriptionId = 0;
    }
    StoreManager.prototype.subscribe = function (callback) {
        this._callbacks.push({ callback: callback, subscription: this._nextSubscriptionId++ });
        return this._nextSubscriptionId - 1;
    };
    StoreManager.prototype.unsubscribe = function (subscriptionId) {
        var subscriptionIndex = this._callbacks
            .map(function (element, index) { return element.subscription === subscriptionId ? { found: true, index: index } : { found: false }; })
            .filter(function (element) { return element.found === true; });
        if (subscriptionIndex.length !== 1) {
            throw new Error("Found an invalid number of subscriptions " + subscriptionIndex.length);
        }
        this._callbacks.splice(subscriptionIndex[0].index, 1);
    };
    StoreManager.prototype.notifySubscribers = function () {
        for (var i = 0; i < this._callbacks.length; i++) {
            var callback = this._callbacks[i].callback;
            callback();
        }
    };
    return StoreManager;
}());
export { StoreManager };
